export default "/images/framework/Vs.ccc73166.svg?ccc73166";